<template>
    <b-modal ref="view-discount-modal"
             hide-footer
             scrollable
             size="lg"
             title="Discount view">
        <div v-if="discount">

            <table class="table table-bordered view-discount">
                <tr>
                    <td class="font-weight-bold">{{ $t("#TR-code") }}</td>
                    <td> {{ discount['code'] }}</td>
                </tr>
                <tr>
                    <td class="font-weight-bold">{{ $t("#TR-name") }}</td>
                    <td> {{ discount['name'] }}</td>
                </tr>
                <tr>
                    <td class="font-weight-bold">{{ $t("#TR-count-type") }}</td>
                    <td>
                        {{ discount['countType'] }} -
                        {{ discount['value'] }}<span
                            v-if="discount['countType'] === 'Percent'">%</span>
                    </td>
                </tr>

                <tr>
                    <td class="font-weight-bold">{{ $t("#TR-starting-sale") }}</td>
                    <td>
                        <span v-if="discount.startSales.enabled">
                            {{ discount.startSales.value }}
                        </span>
                        <span v-if="!discount.startSales.enabled">
                            <i class="mdi mdi-close-circle-outline text-danger mr-2"></i>
                            <span class="text-muted">{{ discount.startSales.value }}</span>
                        </span>
                    </td>
                </tr>
                <tr>
                    <td class="font-weight-bold">{{ $t("#TR-ending-sale") }}</td>
                    <td>
                        <span v-if="discount.stopSales.enabled">{{ discount.stopSales.value }}</span>
                        <span v-if="!discount.stopSales.enabled">
                            <i class="mdi mdi-close-circle-outline text-danger  mr-2"></i>
                            <span class="text-muted">{{ discount.stopSales.value }}</span>
                        </span>
                    </td>
                </tr>
                <tr>
                    <td class="font-weight-bold">{{ $t("#TR-classification") }}</td>
                    <td>{{ discount['classification']
                        ? classificationsList.bySifr[discount['classification']].name
                        : '&mdash;' }}
                    </td>
                </tr>
                <tr>
                    <td class="font-weight-bold">{{ $t("#TR-need-manager") }}</td>
                    <td>
                        <i class="mdi " :class="discount['needManager']
                            ? 'mdi-check-circle-outline  text-success'
                            : 'mdi-close-circle-outline text-danger'"></i>
                    </td>
                </tr>
                <tr>
                    <td class="font-weight-bold">{{ $t("#TR-restrict-manual") }}</td>
                    <td>
                        <i class="mdi" :class="discount['prohibitHand']
                            ? 'mdi-check-circle-outline text-success'
                            : 'mdi-close-circle-outline text-danger'"></i>
                    </td>
                </tr>
            </table>

            <div class="row">
                <div class="col-12 text-center">
                    <b-button variant="danger"
                              type="button"
                              class="mx-1"
                              @click="cancel">
                        <span class="mdi mdi-close"></span> {{ $t("#TR-cancel") }}
                    </b-button>
                    <b-button variant="primary"
                              type="button"
                              class="mx-1"
                              @click="onEdit()">
                        <span class="mdi mdi-pencil"></span> {{ $t("#TR-edit") }}
                    </b-button>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>

import { ApiEditor } from '@/services/api';
import MSG from '@/services/notify';

export default {
    name: 'DiscountView',
    components: {},
    mixins: [],
    props: {
        viewedDiscount: {
            default: () => {
                return null;
            },
            type: Object
        },
        classificationsList: {
            default: () => {
                return null;
            },
            type: Object
        }
    },

    data() {
        return {
            discount: null
        };
    },

    async created() {
        await this.getDiscount();
    },

    methods: {

        async getDiscount() {
            const result = await ApiEditor.getDiscount(this.viewedDiscount.guid);

            if (result.error) {
                MSG.error(result.error, this);
                this.cancel();
            } else {
                this.discount = result.data;
                this.discount.startSales.value = this.$moment(new Date(this.discount.startSales.value)).format('YYYY.MM.DD, HH:mm');
                this.discount.stopSales.value = this.$moment(new Date(this.discount.startSales.value)).format('YYYY-MM-DD, HH:mm');
            }
        },

        onEdit() {
            this.$emit('onEdit', this.discount);
        },

        cancel() {
            this.$refs['view-discount-modal'].hide();
            this.$emit('cancelViewEdit');
        },

        openDiscountView() {
            this.$refs['view-discount-modal'].show();
        }

    }
};
</script>

<style lang="stylus" scoped>

.view-discount {
    .mdi {
        font-size: 24px
        line-height: 24px
    }
}


</style>
